var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.393 16h-6.27c-.165 0-.3.126-.3.28l-.004 8.439c0 .154.135.281.3.281h6.274c.165 0 .3-.127.3-.281V16.28c0-.155-.135-.281-.3-.281zM15 20.5a.5.5 0 11-1 0 .5.5 0 011 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.894 11.113L16.69 7.129a1.91 1.91 0 00-1.384 0l-10.2 3.984C4.44 11.376 4 11.988 4 12.67v12.05c0 .154.135.281.3.281h3c.165 0 .3-.127.3-.281V16c0-.618.548-1.125 1.223-1.125h14.354c.675 0 1.223.507 1.223 1.126v8.719c0 .154.135.281.3.281h3c.165 0 .3-.127.3-.281V12.67c0-.682-.439-1.294-1.106-1.557z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.637 16h6.412c.165 0 .3.126.3.28v8.439c0 .154-.135.281-.3.281h-6.416c-.165 0-.3-.127-.3-.281l.004-8.438c0-.155.135-.281.3-.281zm.863 5a.5.5 0 100-1 .5.5 0 000 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c85d07d47ed8af527db982e073acccb9.svg";
export { ForwardRef as ReactComponent };